import { sagaCreator } from '@adrias-online/steiner';

import { createSagas } from '../../../helpers/portaleModuleHelper';
import { actions, actionTypes } from '../actions/portaliArticoli';
import { selectors, DEFAULT_STATE } from '../reducers/portaliArticoli';
import api from '../apis/portaliArticoli';

const sagas = createSagas(
    'portaliArticoli',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        resourceLabel: 'Articolo'
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
